
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IFacilitiesForDropdown } from '@shared/services/api/legacy/facilities-service/facility-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class FacilitiesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${FacilitiesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/facilities';

    public getFacilitiesForDropdown(): Observable<SuccessResponse<IFacilitiesForDropdown> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IFacilitiesForDropdown>>(FacilitiesService.URL + '/dropdown').pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
